import { render } from "./App.vue?vue&type=template&id=c78481e2"
const script = {}

import "./App.vue?vue&type=style&index=0&id=c78481e2&lang=css"

import exportComponent from "C:\\Users\\erwin\\Dropbox\\My Projects\\JavaScript\\Vue\\vuemastery\\real-world-vue-3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__